import { handleActions } from 'redux-actions';
import * as REQUEST_STATES from 'forms-utils-lib/RequestState';
import { REQUEST_DEFAULT_LEGAL_CONSENT_OPTION, RECEIVE_DEFAULT_LEGAL_CONSENT_OPTION, FAIL_DEFAULT_LEGAL_CONSENT_OPTION } from 'FormsUI/actions/LegalConsentOptions';
const INIT_STATE = {
  defaultLegalConsentOption: null,
  defaultLegalConsentOptionRequestState: REQUEST_STATES.NOT_REQUESTED
};
export default handleActions({
  [REQUEST_DEFAULT_LEGAL_CONSENT_OPTION]: state => Object.assign({}, state, {
    defaultLegalConsentOptionRequestState: REQUEST_STATES.REQUESTED
  }),
  [RECEIVE_DEFAULT_LEGAL_CONSENT_OPTION]: (state, {
    legalConsent
  }) => Object.assign({}, state, {
    other: 1,
    defaultLegalConsentOptionRequestState: REQUEST_STATES.SUCCEEDED,
    defaultLegalConsentOption: legalConsent
  }),
  [FAIL_DEFAULT_LEGAL_CONSENT_OPTION]: state => Object.assign({}, state, {
    defaultLegalConsentOptionRequestState: REQUEST_STATES.REQUESTED
  })
}, INIT_STATE);